import React, {useState} from "react";
import Switch from "react-switch";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons/lib";
import {Form, Tooltip} from "antd";

interface SwitchComponentProps {
  handleChange?(e:any): void;

  required?: boolean;
  label?: string | JSX.Element;
  tooltip?: string | JSX.Element;
  color?: string | undefined
  name?: string
  offHandleColor?: string
  message?: string;
  labelStyle?: any;
  checkDefault?: boolean
  style?: any
}

const SwitchComponent = ({label, checkDefault, style, name, labelStyle, tooltip, handleChange, required, message, offHandleColor = "#4B4B4B"}: SwitchComponentProps) => {
  const [checked, setChecked] = useState<boolean>(checkDefault ? checkDefault : false);

  const checkedIcon = <div
    style={{display: "flex", justifyContent: "center", alignItems: "center", width: "23px", height: "23px"}}>
    <CheckOutlined
      style={{color: "#fff"}}/></div>;
  const uncheckedIcon = <div
    style={{display: "flex", justifyContent: "center", alignItems: "center", width: "23px", height: "23px"}}>
    <CloseOutlined
      style={{color: "#fff"}}/></div>;

  const checkConfirmation = (_rule: any, value: any) => {
    console.log("validator value:", value);
    if (checked) return Promise.resolve();
    return Promise.reject(message);
  };

  const rules = required ? [
    {
      validator: checkConfirmation
    }
  ] : undefined;




  return (
    <div className={"switch-comp"} style={style}>
      <Form.Item
        valuePropName={"checked"}
        style={{display: "flex", justifyContent: "center", margin: "0 20px"}}
        rules={rules}
        name={name}>
        <Switch
          checked={checked}
          onChange={(e) => {
            handleChange && handleChange(e);
            setChecked(!checked)
          }}
          value={checked?1:0}
          uncheckedIcon={false}
          checkedIcon={false}
          offColor="transparent"
          onColor="transparent"
          offHandleColor={offHandleColor}
          onHandleColor="#34B233"
          uncheckedHandleIcon={uncheckedIcon}
          checkedHandleIcon={checkedIcon}
        />
      </Form.Item>
      <div onClick={() => setChecked(!checked)} className={"switch-label"} style={labelStyle}>{label}</div>
      {tooltip && <Tooltip title={tooltip} placement="left"
                           color={"#fff"} overlayStyle={{color: "#000"}}>
          <div style={{marginLeft: "auto"}}><span className={"inputTooltip"}>?</span></div>
      </Tooltip>}
    </div>
  )
};

export default SwitchComponent;
